module.exports = __webpack_public_path__ + "img/placeholder-genre.5a4757ee.svg";